

function Page({heading}) {
  return (
    <div className='w-full h-[500px] bg-slate-500 flex justify-center content-center'>
      <h1 className="text-[10vw] my-auto">{heading}</h1>
    </div>
  )
}

export default Page
